import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import HubSpotAppLink from 'crm-links/common/components/HubSpotAppLink';
import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { allPropertiesHistory } from '../../helpers/crmLinks';
import { HIGHLIGHT_CARD_ACTION_ALL_PROPERTIES, HIGHLIGHT_CARD_ACTION_PROPERTIES_HISTORY, HIGHLIGHT_CARD_ACTIONS_LIST, PROFILE_SETTINGS_ACTIONS_BTN } from '../../constants/dataTestIds';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ALL_PROPERTIES_PANEL = gate('CRM:Records:AllPropertiesPanel');
const HighlightActions = ({
  objectId,
  objectTypeId
}) => {
  const userInfo = userInfoSync();
  const isUngatedForAllPropertiesPanel = useMemo(() => {
    var _userInfo$gates;
    return ((_userInfo$gates = userInfo.gates) === null || _userInfo$gates === void 0 ? void 0 : _userInfo$gates.includes(ALL_PROPERTIES_PANEL)) || false;
  }, [userInfo]);
  const openPropertiesPanel = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_ALL_PROPERTIES_PANEL);
  return /*#__PURE__*/_jsx(Dropdown, {
    menuWidth: 204,
    placement: "bottom right",
    buttonText: I18n.text('highlightCard.buttons.actions'),
    "data-test-id": PROFILE_SETTINGS_ACTIONS_BTN,
    buttonUse: "transparent",
    children: /*#__PURE__*/_jsxs(List, {
      "data-test-id": HIGHLIGHT_CARD_ACTIONS_LIST,
      wrapChildren: true,
      children: [isUngatedForAllPropertiesPanel ? /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: () => {
          openPropertiesPanel({
            objectTypeId,
            objectId: String(objectId)
          });
        },
        "data-test-id": HIGHLIGHT_CARD_ACTION_ALL_PROPERTIES,
        children: I18n.text('highlightCard.buttons.allProperties')
      }) : /*#__PURE__*/_jsx(HubSpotAppLink, {
        linkType: "CRM_OBJECT_RECORD_ALL_PROPERTIES",
        linkTypeProps: {
          includeEschref: true,
          objectTypeId,
          objectId
        },
        LinkComponentProps: {
          'data-test-id': HIGHLIGHT_CARD_ACTION_ALL_PROPERTIES
        },
        children: I18n.text('highlightCard.buttons.allProperties')
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": HIGHLIGHT_CARD_ACTION_PROPERTIES_HISTORY,
        href: allPropertiesHistory({
          objectTypeId,
          objectId
        }),
        children: I18n.text('highlightCard.buttons.propertiesHistory')
      })]
    })
  });
};
export default HighlightActions;